export default __webpack_public_path__ + "static/media/jacketlady.62e4503c.png";